module.exports = __webpack_public_path__ + "img/jingmi2_5kg.6732daf6.jpg";